module.exports = __webpack_public_path__ + "static/media/simplybuilt.65ef1ee5.svg";